var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_1138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0052 0H20.9948C9.41588 0 0 9.4185 0 21C0 25.5938 1.4805 29.8515 3.99787 33.3086L1.38075 41.1101L9.45263 38.5298C12.7733 40.7295 16.7344 42 21.0052 42C32.5841 42 42 32.5789 42 21C42 9.42113 32.5841 0 21.0052 0Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2245 29.6547C32.7178 31.0854 30.7071 32.2719 29.1032 32.6184C28.006 32.852 26.5727 33.0384 21.748 31.0381C15.5766 28.4814 11.6023 22.2102 11.2926 21.8034C10.996 21.3965 8.79883 18.4827 8.79883 15.4692C8.79883 12.4557 10.3292 10.9884 10.9461 10.3584C11.4527 9.84123 12.2901 9.60498 13.0933 9.60498C13.3532 9.60498 13.5868 9.61811 13.7968 9.62861C14.4137 9.65486 14.7235 9.69161 15.1303 10.6655C15.637 11.8861 16.8707 14.8996 17.0177 15.2094C17.1673 15.5191 17.317 15.9391 17.107 16.346C16.9101 16.766 16.7368 16.9524 16.4271 17.3094C16.1173 17.6664 15.8233 17.9394 15.5136 18.3226C15.2301 18.656 14.9098 19.013 15.2668 19.6299C15.6238 20.2336 16.8576 22.247 18.6741 23.864C21.0182 25.9509 22.9187 26.6176 23.5986 26.9011C24.1052 27.1111 24.709 27.0612 25.0791 26.6675C25.549 26.1609 26.1291 25.3209 26.7197 24.494C27.1397 23.9007 27.67 23.8272 28.2265 24.0372C28.7935 24.2341 31.7938 25.7172 32.4107 26.0244C33.0276 26.3341 33.4345 26.4811 33.5841 26.741C33.7311 27.0009 33.7311 28.2215 33.2245 29.6547Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_1138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.400d561b13f7322c8bf990fe4a287fd2.svg";
export { ForwardRef as ReactComponent };